import { lazyWithPreload } from '../../../utilities/lazy-with-preload';


const AnotherDeviceModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'AnotherDeviceModal' */ './AnotherDeviceModal')
);

const BasketModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'BasketModal' */ './BasketModal')
);

const ChangeNameModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'ChangeNameModal' */ './ChangeNameModal')
);

const CloseEditModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'CloseEditModal' */ './CloseEditModal')
);

const ConfirmAddressModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'ConfirmAddressModal' */ './ConfirmAddressModal')
);

const CookiesModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'CookiesModal' */ './CookiesModal')
);

const BoxSliderModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'BoxSliderModal' */ './BoxSliderModal')
);

const FreeFrameModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'FreeFrameModal' */ './FreeFrameModal')
);

const InfoModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'InfoModal' */ './InfoModal')
);

const LoadingCompositionsModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'LoadingCompositionsModal' */ './LoadingCompositionsModal')
);

const LoginModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'LoginModal' */ './LoginModal')
);

const NewGalleryModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'NewGalleryModal' */ './NewGalleryModal')
);

const OutdatedModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'OutdatedModal' */ './OutdatedModal')
);

const RemoveImageModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'RemoveImageModal' */ './RemoveImageModal')
);

const VideoModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'VideoModal' */ './VideoModal')
);

const WelcomeScreenModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'WelcomeScreenModal' */ './WelcomeScreenModal')
);

const NewsletterModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'WelcomeScreenModal' */ './NewsletterModal')
);

const HangingSystemModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'WelcomeScreenModal' */ './HangingSystemModal')
);

const SaveForLaterModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'WelcomeScreenModal' */ './SaveForLaterModal')
);

const MODAL_COMPONENTS = {
    anotherDevice: AnotherDeviceModal,
    basket: BasketModal,
    boxSlider: BoxSliderModal,
    changeName: ChangeNameModal,
    closeEdit: CloseEditModal,
    cookies: CookiesModal,
    confirmAddress: ConfirmAddressModal,
    info: InfoModal,
    freeFrame: FreeFrameModal,
    login: LoginModal,
    loadingCompositions: LoadingCompositionsModal,
    newGallery: NewGalleryModal,
    outdated: OutdatedModal,
    removeImage: RemoveImageModal,
    video: VideoModal,
    welcomeScreen: WelcomeScreenModal,
    newsletter: NewsletterModal,
    hangingSystem: HangingSystemModal,
    saveForLater: SaveForLaterModal,
};

export default MODAL_COMPONENTS;
